import React, { useEffect } from "react";
import { DeleteData, useFirebase } from "../../hooks/firebase/useFirebase";
import { Table, TableBody, TableCell, TableRow } from "@mui/material";
import { GenericSwitch } from "../../components/elements/Switch";
import { Actions } from "../../components/buttons/Actions";
import { Loader } from "../../components/elements/Loader";
import { subCategoryQuery } from "../../constants/api";
import { useAppContext } from "../../context/useAppContext";
import { CategoryForm } from "../../forms/CategoryForm";

export const CategoryRow = ({ parentId }) => {
  const {
    listenData: getCategories,
    data: categories,
    loading,
  } = useFirebase();

  const { contextData } = useAppContext();

  useEffect(() => {
    getCategories(subCategoryQuery(parentId));
  }, [parentId]);

  if (loading) return <Loader />;
  return (
    <div>
      <Table size="small">
        <TableBody>
          {categories?.map((item, i) => (
            <TableRow
              key={i}
              sx={{
                cursor: "pointer",
              }}
              hover
            >
              <TableCell />
              <TableCell
                sx={{ fontSize: 13 }}
                onClick={() =>
                  contextData.showGlobalDrawer({
                    component: <CategoryForm data={item} />,
                    title: "Update Category",
                  })
                }
              >
                {item.category_name}
              </TableCell>
              <TableCell />
              <TableCell align="right">
                <GenericSwitch checked={item.active} end docRef={item.docRef} />
              </TableCell>
              <TableCell align="right">
                <Actions
                  actions={[
                    {
                      action: "Edit",
                      click: () =>
                        contextData.showGlobalDrawer({
                          component: <CategoryForm data={item} />,
                        }),
                    },
                    {
                      action: "Delete",
                      click: () => DeleteData(item.docRef),
                      confirm: true,
                    },
                  ]}
                />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};
